import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"

const EmergencyNumberImage = () => {
  const data = useStaticQuery(graphql`
    query {
      placeholderImage: file(relativePath: { eq: "000-image.png" }) {
        childImageSharp {
          fluid(maxWidth: 200, maxHeight: 232) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)

  return (
    <Img
      fluid={data.placeholderImage.childImageSharp.fluid}
      alt="Fire-and-Rescue-logo"
    />
  )
}

export default EmergencyNumberImage
